import gql from 'graphql-tag';

export const ARTICLE_GROUP_IMAGES_QUERY = gql`
  query ArticleGroupImagesQuery($id: ID!) {
    articleGroup(id: $id) {
      ogImages {
        id
        url
        metrics {
          ctr
          spent
        }
      }
    }
  }
`;
